import { Store, createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunkMiddleware from 'redux-thunk';
import { logger } from 'redux-logger';
import { ApplicationState } from '../models';
import { rootReducer } from '../reducers';

let storeInstance: Store<ApplicationState> | undefined;

export function configureStore(initialState?: ApplicationState): Store<ApplicationState> {
    let enhancer = applyMiddleware(thunkMiddleware);

    if (process.env.NODE_ENV !== 'production') {
        enhancer = composeWithDevTools(applyMiddleware(thunkMiddleware, logger));
    }

    const store = createStore(rootReducer as any, initialState, enhancer) as Store<ApplicationState>;

    if (module.hot) {
        module.hot.accept('../reducers', () => {
            const nextReducer = require('../reducers');
            store.replaceReducer(nextReducer);
        });
    }

    storeInstance = store;
    return store;
}

/**
 * Access to the singleton store for plain (non-component, non-DI-managed) code
 * that needs to read current redux state, e.g. helpers/tokens.ts.
 */
export function getStore(): Store<ApplicationState> | undefined {
    return storeInstance;
}
